import { startsWith } from './../../utils/StringUtils';

export function parseSearchSwitch(term: string, folderId: string): string {
  if (startsWith(term, '-current')) {
    term = term.replace('-current', '');
    term = `folder:${encodeURI(folderId)} ${term.trim()}`;
  } else if (startsWith(term, '-below')) {
    term = term.replace('-below', '');
    term = `below:${encodeURI(folderId)} ${term.trim()}`;
  }

  return term;
}
